"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
const useNetworkErrorReporter = () => {
    const { isDocVisible } = (0, hooks_1.useVisibilityChange)();
    const { isOnline } = (0, hooks_1.useIsOnline)();
    const [wentOffline, setWentOffline] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!isOnline) {
            if (isDocVisible) {
                const errMsg = "Network is unavailable. Are you sure you're connected to the network?";
                (0, utils_1.toastError)(errMsg);
            }
            setWentOffline(true);
        }
    }, [isOnline]);
    (0, react_1.useEffect)(() => {
        if (wentOffline && isOnline) {
            (0, utils_1.toastSuccess)('Network is available', 5000);
            setWentOffline(false);
        }
    }, [isOnline, wentOffline]);
};
exports.default = useNetworkErrorReporter;
